<script setup lang="ts">
import { computed, ref } from 'vue'

import { growthYears } from '../../data/siteContent'

const activeIndex = ref(0)
const activeYear = computed(() => growthYears[activeIndex.value]!)
</script>

<template>
  <section id="growth" class="section growth-section" aria-labelledby="growth-title">
    <div class="growth-section__dust" aria-hidden="true" />
    <div class="section-frame">
      <div class="section-heading section-heading--split" data-reveal>
        <div>
          <p class="section-kicker">02 / FOUR YEARS IN ORBIT</p>
          <h2 id="growth-title">四年成长星系</h2>
        </div>
        <p>这不是学校课程表，而是一张可以自己改写的通用能力地图。</p>
      </div>

      <div class="growth-galaxy" data-reveal>
        <div class="growth-galaxy__map">
          <div class="growth-galaxy__orbits" aria-hidden="true">
            <i v-for="index in 4" :key="index" :style="{ '--index': index }" />
          </div>
          <div class="growth-galaxy__core" aria-hidden="true">
            <span>YOU</span>
            <i />
          </div>
          <button
            v-for="(year, index) in growthYears"
            :key="year.year"
            type="button"
            class="growth-planet"
            :class="{ active: index === activeIndex }"
            :style="{ '--index': index }"
            :aria-pressed="index === activeIndex"
            @click="activeIndex = index"
          >
            <span>{{ year.year }}</span>
            <small>{{ year.code.split(' / ')[1] }}</small>
          </button>
        </div>

        <article class="growth-readout" aria-live="polite">
          <p>{{ activeYear.code }}</p>
          <h3>{{ activeYear.theme }}</h3>
          <span>{{ activeYear.summary }}</span>
          <ul>
            <li v-for="skill in activeYear.skills" :key="skill">
              <i aria-hidden="true" />{{ skill }}
            </li>
          </ul>
          <small>通用成长建议 · 请结合个人方向主动调整</small>
        </article>
      </div>
    </div>
  </section>
</template>
